import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-filtro-busca-texto',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './filtro-busca-texto.component.html',
  styleUrl: './filtro-busca-texto.component.scss',
})
export class FiltroBuscaTextoComponent {
  @Input() value = '';
  @Input() placeholder = 'Buscar';
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<string>();

  onChange(value: string): void {
    this.value = value;
    this.valueChange.emit(value);
  }
}
